import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class BookLibrarySerializer extends ApplicationSerializer {
  // Prefix book-library/ to any 'type' keys from the response payload, to get the model name
  modelNameFromPayloadKey(key: string) {
    // these json-api "type": "x" values should not be prefixed with "book-library/"
    // plural types are from library_api, singular types are from ember-data-factory-guy
    const noPrefix = ['students', 'student', 'teachers', 'teacher']
    if (noPrefix.includes(key)) {
      return super.modelNameFromPayloadKey(key) // these models exist outside the book-library namespace
    } else if (key.startsWith('book-library/')) {
      // already prefixed
      return super.modelNameFromPayloadKey(key)
    } else {
      return super.modelNameFromPayloadKey(`book-library/${key}`)
    }
  }

  // Remove book-library/ from any model name, to get the 'type' key for the request payload
  payloadKeyFromModelName(modelName: string) {
    const updatedModelName = modelName.replace('book-library/', '')
    return super.payloadKeyFromModelName(updatedModelName)
  }
}
